var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "checkout-section" },
    [
      _c(
        "div",
        { staticClass: "checkout-section__skip" },
        [
          _c("NavButton", {
            attrs: {
              text: _vm.data.addons.bookWithoutExtensionText,
              stepAmount: 2,
            },
            on: { beforeNextStep: _vm.bookWithoutExtension },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "checkout-section__header" }, [
        _c("h2", { staticClass: "checkout-section__title" }, [
          _vm._v(_vm._s(_vm.data.addons.title)),
        ]),
        _vm._v(" "),
        _c("div", {
          staticClass: "checkout-section__description",
          domProps: { innerHTML: _vm._s(_vm.data.addons.descriptionHtml) },
        }),
      ]),
      _vm._v(" "),
      _vm.addonData.addOns && _vm.addonData.addOns.length
        ? _c("AddOnList", {
            attrs: {
              initialData: _vm.addonData,
              brand: _vm.data.brandNameFormatted,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "checkout-section__footer" },
        [
          _c("NavButton", {
            attrs: { back: true, text: "Back", isFirstPage: true },
          }),
          _vm._v(" "),
          _c("NavButton", {
            attrs: {
              text: _vm.data.addons.bookWithoutExtensionText,
              stepAmount: 2,
            },
            on: { beforeNextStep: _vm.bookWithoutExtension },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }